import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody, Button,
} from 'reactstrap';
import { history, routeConstants } from '../../utils';

function PageLeaveAlert(props) {
  const {
    isOpen, onClose, isFromModal, handleCancelButton,
  } = props;

  const [modal, setModal] = useState(isOpen);
  const toggle = () => {
    setModal(!modal);
    onClose();
  };
  const hideModal = () => {
    toggle();
    onClose();
  };

  const handleOk = () => {
    hideModal();
    if (!isFromModal) {
      document.body.classList.remove('bg-grey');
      const { isOfferListing, offerId = null } = history.location?.state;
      const routeToRedirect = isOfferListing ? `${routeConstants.ADMIN_OFFER}` : `${routeConstants.OFFER_DETAIL}/${offerId}`;
      history.push(routeToRedirect);
    } else {
      handleCancelButton();
    }
  };

  return (
    <Modal isOpen={modal} className="modal-logout modal-dialog-centered modal-logout-admin">
      <ModalBody>
        <p className="text-left">
          If you leave this page, your data will not be saved.
        </p>
        <div className="button-wrapper">
          <Button
            color="secondary"
            size="xs"
            className="btn-small"
            onClick={hideModal}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            className="btn-small"
            onClick={() => { handleOk(); }}
          >
            OK
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}

PageLeaveAlert.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isFromModal: PropTypes.bool,
  handleCancelButton: PropTypes.func,
};

PageLeaveAlert.defaultProps = {
  isFromModal: false,
  handleCancelButton: null,
};

export default PageLeaveAlert;
